export default __webpack_public_path__ + "static/media/legend-map.887bf5fb.png";